module.exports = __webpack_public_path__ + "static/media/logo_latam.1f690456.svg";